export type LoadingSpinnerProps = {
    text?: string,
    theme?:"light"|"dark"
}

export const LoadingSpinner = ({text , theme}:LoadingSpinnerProps) => {
    const squareStyle = { backgroundColor: theme === "light" ? "#ffffff" : "#333333"}
    return (
        <div className="flex justify-center m-5">
             <div className="loader pointer-events-none">
                <div style={squareStyle} className={"loader-square"}></div>
                <div style={squareStyle} className={"loader-square"}></div>
                <div style={squareStyle} className={"loader-square"}></div>
                <div style={squareStyle} className={"loader-square"}></div>
                <div style={squareStyle} className={"loader-square"}></div>
                <div style={squareStyle} className={"loader-square"}></div>
                <div style={squareStyle} className={"loader-square"}></div>
            </div>
            <span className="text-gray-700 font-medium ml-4">{text}</span>
        </div>
    )
}